import { render, staticRenderFns } from "./LizMann.vue?vue&type=template&id=4bbf8aba&scoped=true&"
import script from "./LizMann.vue?vue&type=script&lang=js&"
export * from "./LizMann.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf8aba",
  null
  
)

export default component.exports